// components
import { GridColumnMenu } from '@mui/x-data-grid-pro';
import { EmployeeNameFormatItem } from './EmployeeNameFormatItem';

// types
import type { CustomColumnMenuProps } from './CustomColumnMenu.types';

export default function CustomColumnMenu({
  employeeNameFormat,
  onSelectEmployeeNameFormat,
  ...props
}: CustomColumnMenuProps) {
  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuUserItem: EmployeeNameFormatItem
      }}
      slotProps={{
        columnMenuUserItem: {
          displayOrder: 1,
          nameFormat: employeeNameFormat,
          onSelectNameFormat: onSelectEmployeeNameFormat
        }
      }}
    />
  );
}
